import React from "react";

import { useLocation, useParams, useToggleNavs, useTranslation } from "utils";

import { Col, FarmFieldCard, Link, MainPage, NavigationHeader, Row, Typography } from "components";

export const SplitSuccess = () => {
  const { t } = useTranslation(["farm", "meta"]);
  const { field1Id, field2Id } = useParams();
  const location = useLocation();
  useToggleNavs(false, true);

  const returnTo = location.state?.returnTo || "/all-fields";

  return (
    <MainPage dataTestId="split-success-page" loading={false} pageName={"splitSuccess"} containerClass="tiny">
      <NavigationHeader title="" link={returnTo} mixpanelText={t("farm:fieldSplitting.fieldSplitSuccess.skip")} />
      <Row>
        <Col>
          <Typography variant="h1" className="center margin-bottom-100">
            {t("farm:fieldSplitting.fieldSplitSuccess.heading")}
          </Typography>
          <Typography variant="paragraph-m" className="center margin-bottom-400">
            {t("farm:fieldSplitting.fieldSplitSuccess.description")}
          </Typography>
        </Col>
      </Row>
      <section className="container tiniest">
        <Typography variant="h4" className="center margin-bottom-175">
          {t("farm:fieldSplitting.fieldSplitSuccess.updateFieldData")}
        </Typography>
        <Row justify="center">
          <Col>
            <FarmFieldCard dataTestId="split-success-page-field-card-1" fieldId={field1Id || ""} />
          </Col>
        </Row>
        <Row className="margin-bottom-150" justify="center">
          <Col>
            <FarmFieldCard dataTestId="split-success-page-field-card-2" fieldId={field2Id || ""} />
          </Col>
        </Row>
        <Row justify="center">
          <Col className="center">
            <Link to={returnTo} dataTestId="split-success-page-skip-link" mixpanelText={t("farm:fieldSplitting.fieldSplitSuccess.skip")}>
              {t("farm:fieldSplitting.fieldSplitSuccess.skip")}
            </Link>
          </Col>
        </Row>
      </section>
    </MainPage>
  );
};
